import { Chip } from '@mui/material';

const STATUS_STYLE = {
    draft: { label: 'Draft', color: '#b26a00' },
    confirmed: { label: 'Confirmed', color: '#2e7d32' },
    parsing: { label: 'Parsing', color: '#0277bd' },
    failed: { label: 'Failed', color: '#d92936' },
};

/** 문서 상태 칩(Draft·Confirmed, 카드에서는 Parsing·Failed도). 문서 카드와 업로드 다이얼로그 헤더가 같은 모양으로 쓴다. */
export default function DocStatusChip({ status, sx }) {
    const style = STATUS_STYLE[status] ?? { label: status, color: '#6b7a82' };
    return <Chip size="small" label={style.label} sx={{ bgcolor: style.color, color: 'white', fontSize: 10, fontWeight: 500, height: 18, ...sx }} />;
}

/** 지금 고치는 중이라는 표시. 상태 칩 옆에 붙는다. 바탕 없이 주황 테두리와 글자만 둔다. */
export function EditingChip({ sx }) {
    return <Chip size="small" variant="outlined" label="Editing" sx={{ color: '#ffe0b2', borderColor: '#ffe0b2', fontSize: 10, fontWeight: 500, height: 18, ...sx }} />;
}

export function ReadOnlyChip({ sx }) {
    return <Chip size="small" variant="outlined" label="Read-only" sx={{ color: '#c7c7c7', borderColor: '#c7c7c7', fontSize: 10, fontWeight: 500, height: 18, ...sx }} />;
}